import React from 'react';
import PropTypes from 'prop-types';
import { CopyIcon, InfoIcon } from '../../model/icons';

// Карточка приглашения: заголовок, подпись, поле со ссылкой + копирование,
// опциональная заметка и доп. контент (QR). Переиспользуется для орг/студентов.
export default function InviteCard({ title, lead, url, onCopy, note, children }) {
    return (
        <section className="camp-card">
            <h3>{title}</h3>
            <div className="lead">{lead}</div>
            <div className="copy-row">
                <input className="input" readOnly value={url} />
                <button type="button" className="cbtn-ico" onClick={() => onCopy(url)} aria-label="Копировать ссылку">
                    <CopyIcon />
                </button>
            </div>
            {note && (
                <div className="camp-note">
                    <InfoIcon />
                    {note}
                </div>
            )}
            {children}
        </section>
    );
}

InviteCard.propTypes = {
    title: PropTypes.string.isRequired,
    lead: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    onCopy: PropTypes.func.isRequired,
    note: PropTypes.string,
    children: PropTypes.node
};

InviteCard.defaultProps = {
    note: null,
    children: null
};
